import { Circle, Plus, TicketPercent } from 'lucide-react';
import React from 'react';

export const EmptyVoucher: React.FC = () => {
  return (
    <div className='flex flex-col items-center justify-center p-6 text-center'>
      <div className='relative mb-10'>
        <div className='relative'>
          <TicketPercent className='h-16 w-24 text-gray-400' strokeWidth={0.6} />

          <Circle className='absolute -right-1 -top-1 h-4 w-4 text-gray-300' />
          <Circle className='absolute -bottom-1 -left-1 h-3 w-3 text-gray-400' />

          {/* Plus and circle decorative elements in grey */}
          <Plus className='absolute -left-2 top-2 h-3 w-3 text-gray-300' />
          <Circle className='absolute -top-2 left-2 h-2 w-2 fill-current text-gray-300' />
          <Plus className='absolute -bottom-2 right-2 h-2 w-2 fill-current text-gray-400' />
        </div>
      </div>

      <h3 className='mb-1 text-base font-medium text-foreground'>No vouchers available</h3>
      <p className='text-sm text-muted-foreground'>Enter voucher code in the column above</p>
    </div>
  );
};
